if (!customElements.get("cart-drawer-bundle")) {
  customElements.define(
    "cart-drawer-bundle",
    class CartDrawerBundle extends HTMLElement {
      constructor() {
        super();
        this.buttons = this.querySelectorAll("[data-bundle-add]");
        this.errorElement = this.querySelector("[data-bundle-error]");
        this.buttons.forEach((button) =>
          button.addEventListener("click", this.onAddClick.bind(this)),
        );
        this.initSlider();
      }

      initSlider() {
        this.slider = this.querySelector("[data-bundle-slider]");
        if (!this.slider) return;

        this.slides = Array.from(this.slider.children);
        this.prevButton = this.querySelector("[data-bundle-slider-prev]");
        this.nextButton = this.querySelector("[data-bundle-slider-next]");
        this.dots = this.querySelectorAll("[data-bundle-slider-dot]");

        this.prevButton?.addEventListener("click", () =>
          this.goToSlide(this.currentSlide - 1),
        );
        this.nextButton?.addEventListener("click", () =>
          this.goToSlide(this.currentSlide + 1),
        );
        this.dots.forEach((dot) =>
          dot.addEventListener("click", () =>
            this.goToSlide(parseInt(dot.dataset.bundleSliderDot, 10)),
          ),
        );

        this.currentSlide = 0;
        this.slider.addEventListener("scroll", this.updateSlider.bind(this), {
          passive: true,
        });
        this.updateSlider();
      }

      goToSlide(index) {
        const slide = this.slides[index];
        if (!slide) return;

        this.slider.scrollTo({
          left: slide.offsetLeft - this.slides[0].offsetLeft,
          behavior: "smooth",
        });
      }

      updateSlider() {
        const step =
          this.slides[1].offsetLeft - this.slides[0].offsetLeft ||
          this.slider.clientWidth ||
          1;
        this.currentSlide = Math.min(
          this.slides.length - 1,
          Math.max(0, Math.round(this.slider.scrollLeft / step)),
        );

        this.dots.forEach((dot, index) => {
          if (index === this.currentSlide) {
            dot.setAttribute("aria-current", "true");
          } else {
            dot.removeAttribute("aria-current");
          }
        });
        if (this.prevButton) this.prevButton.disabled = this.currentSlide === 0;
        if (this.nextButton)
          this.nextButton.disabled = this.currentSlide === this.slides.length - 1;
      }

      onAddClick(event) {
        event.preventDefault();
        const button = event.currentTarget;
        if (
          button.disabled ||
          button.getAttribute("aria-disabled") === "true" ||
          this.classList.contains("is-loading")
        )
          return;

        // Per-product buttons carry their own variant data; the combined button uses the element's.
        const source = button.dataset.variantIds ? button.dataset : this.dataset;
        const cart = document.querySelector("cart-drawer");
        const variantIds = (source.variantIds || "")
          .split(",")
          .map((id) => parseInt(id, 10))
          .filter(Boolean);
        const variantQuantities = (source.variantQuantities || "")
          .split(",")
          .map((quantity) => parseInt(quantity, 10));

        if (variantIds.length < 1) return;

        this.setLoading(button, true);
        this.handleErrorMessage();

        const body = JSON.stringify({
          items: variantIds.map((id, index) => ({
            id,
            quantity: variantQuantities[index] > 0 ? variantQuantities[index] : 1,
          })),
          sections: cart
            ? cart.getSectionsToRender().map((section) => section.id)
            : [],
          sections_url: window.location.pathname,
        });

        fetch(`${routes.cart_add_url}`, { ...fetchConfig(), body })
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.handleErrorMessage(
                response.description || window.cartStrings.error,
              );
              return;
            }

            if (!cart) {
              window.location = window.routes.cart_url;
              return;
            }

            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: "cart-drawer-bundle",
              cartData: response,
            });

            cart.renderContents(response);
            if (cart.classList.contains("is-empty"))
              cart.classList.remove("is-empty");
          })
          .catch((error) => {
            console.error(error);
            this.handleErrorMessage(window.cartStrings.error);
          })
          .finally(() => {
            this.setLoading(button, false);
          });
      }

      setLoading(button, loading) {
        // Block every bundle button while a request is in flight.
        this.classList.toggle("is-loading", loading);
        button.classList.toggle("loading", loading);
        if (loading) {
          button.setAttribute("aria-disabled", "true");
        } else {
          button.removeAttribute("aria-disabled");
        }
        button.querySelector(".loading__spinner")?.classList.toggle(
          "hidden",
          !loading,
        );
      }

      handleErrorMessage(errorMessage = false) {
        if (!this.errorElement) return;

        this.errorElement.classList.toggle("hidden", !errorMessage);
        if (errorMessage) this.errorElement.textContent = errorMessage;
      }
    },
  );
}
